import { useMemo } from "react";

import type { ColumnsType } from "@similarweb/pro-logic-components";

import {
    type ICommonData,
    type IGroupedDomainData,
    useCommonColumnsConfig,
} from "../../../hooks/useCommonColumnsConfig";
import { type IShareColumnData, useShareColumnConfig } from "../hooks/useShareColumnConfig";

export type Data = ICommonData & IShareColumnData & IGroupedDomainData;

export const useColumnsConfig = () => {
    const { groupedDomainColumn, popColumn, trendColumn, yoyColumn } = useCommonColumnsConfig();
    const shareColumn = useShareColumnConfig();

    return useMemo(
        () => [groupedDomainColumn, shareColumn, trendColumn, popColumn, yoyColumn] satisfies ColumnsType<Data>,
        [groupedDomainColumn, popColumn, shareColumn, trendColumn, yoyColumn],
    );
};
